import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate } from '@angular/router';
import { DynamicThemeService } from './dynamic-theme.service';

@Injectable({
  providedIn: 'root',
})
export class LibraryThemeGuard implements CanActivate, CanDeactivate<any> {
  constructor(private readonly themeService: DynamicThemeService) {}

  canActivate(): boolean {
    this.themeService.loadDispatchTheme();
    return true;
  }

  canDeactivate(): boolean {
    this.themeService.removeCurrentTheme();
    return true;
  }
}
